import { MIN_VERSION_APP_VSC_DELETE } from '../constants';
import { compareVersionNumeric } from './generic';
import { identifyReader } from './identifyReader';
import PCSC from './pcsc';

const VSC_READER_PREFIX = 'Microsoft Virtual Smart Card';

export const defaultPresenceDeps = {
    version: () => PCSC.version(),
    listReaders: () => PCSC.list(),
    identify: identifyReader,
};

async function scanVscSerials({ version, listReaders, identify }) {
    const serials = new Set();
    let ver;
    let readers;
    try {
        ver = await version();
    } catch (e) {
        return serials;
    }
    // Only the native app gates `dvsc`: the extension auto-updates, the app does not.
    if (compareVersionNumeric(ver && ver.app, MIN_VERSION_APP_VSC_DELETE) < 0) {
        return serials;
    }
    try {
        readers = (await listReaders()) || [];
    } catch (e) {
        return serials;
    }
    const vscReaders = readers.filter((r) => r.startsWith(VSC_READER_PREFIX));
    for (let i = 0; i < vscReaders.length; i += 1) {
        try {
            // eslint-disable-next-line no-await-in-loop
            const card = await identify(vscReaders[i]);
            if (card && card.serial) {
                serials.add(card.serial);
            }
        } catch (e) {
            // An unreadable reader only hides its own card; keep scanning the rest.
        }
    }
    return serials;
}

// Serials of the VSCs this machine can provably delete. Older bridges reject
// `dvsc`, so any failure, timeout, or too-old app resolves to an empty Set
// (rows hidden), keeping old-bridge endpoints identical to UP 2.27. Silent by
// design: it never throws, dispatches, or shows UI.
export async function detectLocalVscSerials({
    version, listReaders, identify, timeoutMs = 7000,
}) {
    let timer;
    const timeout = new Promise((resolve) => {
        timer = setTimeout(() => resolve(new Set()), timeoutMs);
    });
    try {
        return await Promise.race([scanVscSerials({ version, listReaders, identify }), timeout]);
    } catch (e) {
        return new Set();
    } finally {
        clearTimeout(timer);
    }
}
